import React from "react";

const Minus = () => {
  return (
    <path d="M30.6985646,15 C31.4173275,15 32,15.6715729 32,16.5 C32,17.3284271 31.4173275,18 30.6985646,18 L1.30143541,18 C0.582672479,18 0,17.3284271 0,16.5 C0,15.6715729 0.582672479,15 1.30143541,15 L30.6985646,15 Z" />
  );
};

export default Minus;
